<template>
  <div class="my-5 flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="display-3 mr-4">Coming Soon</h1>
            <div class="text-muted">{{(message ? message : 'The page you are looking for is under development.')}}</div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  props: ['message']
}
</script>
